import React from 'react';
import MainLayout, { useMainLayoutContext } from '../components/MainLayout';
import ClockInOut from '../shared/components/ClockInOut';
import EqxCard from '../shared/components/EqxCard/EqxCard';
import EqxError from '../shared/components/EqxError';
import EqxLoading from '../shared/components/EqxLoading';

// Main content component extracted from PageTimelog
const TimelogContent: React.FC = () => {
    // Check allowed
    const mainContext = useMainLayoutContext()
    if (!mainContext.user) {
        return <EqxLoading />;
    }
    if (!mainContext.user?.staffID) {
        if (!mainContext.user) {
            return <EqxLoading />
        } else {
            return <EqxError error="Only staff can view timelog" />;
        }
    }
    if (!mainContext.permissions?.canClockInOut) {
        return <EqxError error="You do not have permission to Clock In/Out using this app" />;
    }

    return (
        <EqxCard isSection>
            <ClockInOut />
        </EqxCard>
    );
};

const PageTimelog: React.FC = () => {
    return (
        <MainLayout pageTitle="Timelog">
            <TimelogContent />
        </MainLayout>
    );
};

export default PageTimelog; 